import { FormGroup } from '@angular/forms';

export function getInvalidFieldListFromFormGroup(
  formGroup: FormGroup
): { id: string; errors: string[] }[] {
  return Object.keys(formGroup.controls)
    .map((key) => ({ key, control: formGroup.controls[key] }))
    .filter(({ control }) => control.invalid)
    .map(({ control, key }) => {
      return {
        id: key,
        errors: Object.keys(control.errors).map(
          (errorCode) => errorCode + ':' + control.errors[errorCode]
        ),
      };
    });
}
